export function EmptyProducts() {
  return (
    <div className="rounded border border-dashed border-border bg-secondary/40 px-8 py-20 text-center">
      <p className="font-display text-2xl">No products found</p>
      <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground">
        Our collection is being prepared. Please check back shortly — or send us a message to
        discuss a custom piece.
      </p>
    </div>
  );
}
